export default __webpack_public_path__ + "static/media/emptyImage2.9ea63b91.webp";